import React from 'react';

import { useAppSelector } from 'src/app/hooks';
import { getSelectAsset } from 'src/state';
import styles from './Symbol.module.css';

interface Props {
  symbolId: string;
}

export function Symbol({ symbolId }: Props) {
  const symbolAsset = useAppSelector(getSelectAsset(symbolId));
  const symbolUrl = symbolAsset.fields.file['en-US'].url;
  return <img className={styles['symbol']} src={symbolUrl} alt="symbol" />
}
